import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import './time.css';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppSelect } from '../AppSelect';
import { PART_OF_DAY, TIME_FORMAT, TimeHelper } from './time.helper';
import { AppInputWrapper } from '../AppInputWrapper';

class Time extends Component {


    state = {
        timeFormat: this.props.initialValues.timeFormat || TIME_FORMAT.LONG,
        label: this.props.initialValues.label || 'Time label',
        required: this.props.initialValues.isRequired ||  false,
        hoursValue: '',
        minutesValue: '',
        partOfDayValue: PART_OF_DAY.AM,
        requiredError: !!this.props.initialValues.isRequired,

        hours: TimeHelper.hours(this.props.initialValues.timeFormat || TIME_FORMAT.LONG),
        minutes: TimeHelper.minutes,
    };

    updateInputPropsInStore = () => {
        const { label, required, hoursValue, minutesValue, timeFormat, partOfDayValue } = this.state;

        let time = '';
        if (hoursValue && minutesValue) {
            time = hoursValue + ':' + minutesValue;
            if (timeFormat === TIME_FORMAT.SHORT) {
                time += ' ' + partOfDayValue;
            }
        }

        const inputProps = {
            timeFormat,
            label,
            isRequired: required,
            type: this.props.initialValues.type,
            _value: time,
            _hasValidationErrors: this.state.requiredError,
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    setLabel = (e) => {
        this.setState({ label: e.target.value });
    };

    setTimeFormat = (e) => {
        this.setState({
            timeFormat: e.target.value,
            hours: TimeHelper.hours(e.target.value)
        });
    };

    setRequired = (e) => {
        this.setState({ required: e.target.checked });
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
   }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    handleChangeTime = (name, e) => {
        this.setState({ [name]: e.value }, () => {
            this.updateRequiredError();
        });
    };

    updateRequiredError = () => {
        let requiredError;
        if (!this.state.required) {
            requiredError = false;
        } else {
            requiredError = !(this.state.hoursValue && this.state.minutesValue);
        }
        this.setState({ requiredError });
    };

    render() {
        const { color, textColor, isResultInput } = this.props;
        return (
            <>
                <AppInputWrapper
                    label={this.state.label}
                    color={textColor}
                    required={this.state.required}
                    requiredError={this.state.requiredError}
                >
                    <div className="time-container">
                        <label className="time-label">
                            <AppSelect
                                color={color}
                                value={this.state.hoursValue}
                                placeholder="Hours"
                                options={this.state.hours}
                                onChange={(e) => this.handleChangeTime('hoursValue', e)}
                            />
                        </label>
                        <label className="time-label">
                            <AppSelect
                                color={color}
                                value={this.state.minutesValue}
                                placeholder="Minutes"
                                options={this.state.minutes}
                                onChange={(e) => this.handleChangeTime('minutesValue', e)}
                            />
                        </label>

                        {
                            this.state.timeFormat === TIME_FORMAT.SHORT &&
                            <label className="part-of-day-label">
                                <AppSelect
                                    color={color}
                                    value={this.state.partOfDayValue}
                                    options={TimeHelper.partsOfDay}
                                    onChange={(e) => this.handleChangeTime('partOfDayValue', e)}
                                />
                            </label>
                        }
                    </div>

                </AppInputWrapper>

                {
                    !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">
                            <label>
                                <select
                                    value={this.state.timeFormat}
                                    onChange={this.setTimeFormat}
                                >
                                    <option value={TIME_FORMAT.LONG}>{ TIME_FORMAT.LONG }</option>
                                    <option value={TIME_FORMAT.SHORT}>{ TIME_FORMAT.SHORT }</option>
                                </select>
                                time format
                            </label>

                            <label>
                                <input value={this.state.label} onChange={this.setLabel} type="text"/>
                                label
                            </label>

                            <label>
                                <input checked={this.state.required} onChange={this.setRequired} type="checkbox"/>
                                required
                            </label>
                        </div>
                    </AppCollapsible>
                }
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(Time);
